import { useEffect, useState } from 'react';

// Medidas del viewport pintadas en pantalla. Solo existe en compilaciones con
// VITE_DEBUG_VIEWPORT=1: en un teléfono real no hay consola, y un hueco bajo
// la barra inferior solo se explica viendo si encogió la ventana (innerHeight),
// si se desplazó (scrollY) o si cambió la zona segura.
export default function DebugViewport() {
  const [t, setT] = useState('');
  useEffect(() => {
    const sonda = document.createElement('div');
    sonda.style.cssText = 'position:fixed;visibility:hidden;padding-bottom:env(safe-area-inset-bottom,0px);padding-top:env(safe-area-inset-top,0px)';
    document.body.appendChild(sonda);
    const unidades = ['100vh', '100svh', '100lvh', '100dvh'].map((u) => {
      const d = document.createElement('div');
      d.style.cssText = `position:fixed;visibility:hidden;height:${u}`;
      document.body.appendChild(d);
      return d;
    });
    const medir = () => {
      const cs = getComputedStyle(sonda);
      const vhs = unidades.map((d) => Math.round(d.getBoundingClientRect().height)).join('/');
      setT([
        `vh/svh/lvh/dvh ${vhs}`,
        `standalone ${window.matchMedia('(display-mode: standalone)').matches}`,
        `in ${window.innerWidth}×${window.innerHeight}`,
        `vv ${Math.round(window.visualViewport?.height ?? 0)}@${Math.round(window.visualViewport?.offsetTop ?? 0)}`,
        `doc ${document.documentElement.clientHeight}`,
        `scr ${window.scrollX},${window.scrollY}`,
        `safe ${cs.paddingTop}/${cs.paddingBottom}`,
        `screen ${window.screen.height}`,
      ].join(' · '));
    };
    medir();
    const id = setInterval(medir, 400);
    return () => { clearInterval(id); sonda.remove(); unidades.forEach((d) => d.remove()); };
  }, []);
  return (
    <div style={{ position: 'fixed', top: 'env(safe-area-inset-top, 0px)', left: 0, right: 0, zIndex: 99999, padding: '2px 6px', background: 'rgba(255,0,0,0.75)', color: '#fff', font: '11px/1.3 monospace', pointerEvents: 'none', whiteSpace: 'pre-wrap' }}>
      {t}
    </div>
  );
}
